export default __webpack_public_path__ + "static/media/login_logo.5ac728b7.png";